module.exports = __webpack_public_path__ + "static/media/Grzanie.a528a278.svg";